import Swiper, { Pagination, Navigation } from 'swiper';
import 'swiper/css';

window.addEventListener('load', (e) => {
	const sliderBlockSwiper = document.querySelector('.slider-block-swiper');

	if (sliderBlockSwiper) {
		const prodSlider = new Swiper(sliderBlockSwiper, {
			modules: [Pagination, Navigation],
			spaceBetween: 20,
			slidesPerView: 1.1,
			pagination: {
				el: sliderBlockSwiper.querySelector('.swiper-pagination'),
				clickable: true,
			},
			navigation: {
				nextEl: sliderBlockSwiper.querySelector('.swiper-button-next'),
				prevEl: sliderBlockSwiper.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				1160: {
					slidesPerView: 2.2,
					slidesPerGroup: 2,
				},
				1460: {
					slidesPerView: 2.6,
					slidesPerGroup: 3,
				},
			},
		});
	}
});
